export default {
    methods: {
        getResponseErrors(error) {
            if (!error.hasOwnProperty('response')) {
                return null;
            }

            if (!error.response.hasOwnProperty('status')) {
                return null;
            }

            if (error.response.status !== 422) {
                return null;
            }

            return error.response.data.errors;
        }
    },
}